import { Controller } from "stimulus";
import ModalOverlay from "./../components/modal-overlay";

const CLASS_MENU_ACTIVE = "is-fly-menu-active";

export default class extends Controller {
    opened = false;
    resizeTimer;

    static targets = ["menu"];

    initialize() {
        this.onResize = this.onResize.bind(this);
        this.close = this.close.bind(this);
        this.tick = this.tick.bind(this);
    }

    connect() {
        this.modalOverlay = new ModalOverlay({
            onClick: this.close
        });
        window.addEventListener("load", this.tick);
        window.addEventListener("resize", this.onResize);
    }

    onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.tick, 100);
    }

    tick() {
        const rect = this.menuTarget.getBoundingClientRect();
        this.element.style.height = `${rect.height}px`;
    }

    toggle() {
        if (this.opened) this.close();
        else this.open();
    }

    open() {
        if (this.opened) return;
        this.opened = true;
        this.modalOverlay.activate();
        this.element.classList.add(CLASS_MENU_ACTIVE);

        // Fire virtual pageview when user clicks on the "Products" secondary navigation menu item.
        this.sendVirtualPageView("/products-menu");
    }

    close() {
        if (!this.opened) return;
        this.opened = false;
        this.modalOverlay.deactivate();
        this.element.classList.remove(CLASS_MENU_ACTIVE);

        // Fire virtual pageview when user closes the menu
        this.sendVirtualPageView(window.location.pathname);
    }

    sendVirtualPageView(pathname) {
        const { ga } = window;

        if (!ga) {
            console.warn(
                "Google Analytics is not loaded - Can't send virtual page view"
            );
            return;
        }

        ga("set", "page", pathname);
        ga("send", "pageview");
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/fly-menu_controller.js